import { PostingModel } from "app/models/PostModel";
import { usePostingFormBase } from "app/utils/hooks/usePostingFormBase";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "typedefs";

interface Props {
  onPost: (post: PostingModel) => void;
}

export const useTeamsPostingForm = ({ onPost }: Props) => {
  const { selectedTeam } = useSelector(
    (state: RootState) => state.teamGroup,
    shallowEqual,
  );

  const { user, canUploadMedia, postActions } = usePostingFormBase({
    entityPlanPermissions: selectedTeam?.planPermissions,
  });

  const onSubmit = (data: PostingModel) => {
    if (selectedTeam) {
      postActions
        .createPost({ ...data, team_group_ids: [selectedTeam.id] })
        .then((res) => {
          if (res && onPost) {
            onPost(res);
          }
        });
    }
  };

  return {
    selectedTeam,
    canUploadMedia,
    user,
    onSubmit,
  };
};
